import React, { useEffect, useState } from "react";
import toggleXicon from "../../../assets/images/svg/toggleXicon.svg";
import button_yellow_left_layer from "../../../assets/images/svg/button-yellow-left-layer.svg";
import button_yellow_right_layer from "../../../assets/images/svg/button-yellow-right-layer.svg";
import popupside from "../../../assets/images/places/popups/png/popupside.png";
import popuptop_bottom_layer from "../../../assets/images/places/popups/png/popuptop-bottom-layer.png";
const Modal = ({ showPopup, data }) => {
  const initialContent = data.subDescription;
  const [content, setContent] = useState(initialContent);
  const [showFullContent, setShowFullContent] = useState(false);
  const [characterLimit, setCharacterLimit] = useState(330);
  const initialContentsecond = data.description;
  const [contentSecond, setContentSecond] = useState(initialContentsecond);
  const [showFullContentSecond, setShowFullContentSecond] = useState(true);
  const toggleContentSecond = () => {
    setShowFullContentSecond(!showFullContentSecond);
  };
  useEffect(() => {
    const handleResize = () => {
      // Adjust character limit based on screen width
      if (window.innerWidth < 1200) {
        setCharacterLimit(170);
      } else {
        setCharacterLimit(330);
      }
    };

    // Initial check on component mount
    handleResize();

    // Listen for window resize events
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const toggleContent = () => {
    setShowFullContent(!showFullContent);
  };

  return (
    <>
      <div className="position-fixed px-2 px-sm-3 max_w_full w-100 top-50 start-50 translate-middle z_index_4">
        <div className="mx-auto d-flex justify-content-center align-items-center flex-column flex-lg-row ">
          <img
            className="rotate_img popup_top_img w-100 d-lg-none mt_min_1"
            src={popuptop_bottom_layer}
            alt="popuptop-bottom-layer"
          />
          <div className="bg_orange bg_orange_popup_width p_36 position-relative z-3 ">
            <img
              className={`rotate_img position-absolute d-none d-lg-block  h-100 top-0 popup_left_img ${data.lefSide}`}
              src={popupside}
              alt="popupside"
            />
            <img
              className={`d-none d-lg-block h-100 position-absolute  top-0 popup_right_img ${data.rightSide}`}
              src={popupside}
              alt="popupside"
            />
            <img
              onClick={() => showPopup()}
              src={toggleXicon}
              className="position-absolute popup_crose_btn transition_03"
              alt="cross"
            />
            <div className="h-100 overflow-auto mobile_scrollbar">
              <div className="d-flex flex-column flex-lg-row align-items-center align-items-lg-start gap_36 max_w_full mx-auto text-center text-lg-start">
                <div className="position-relative soul-img-width w-100 ml-auto">
                  <div className="position-absolute w-100 d-flex justify-content-center bottom-0 pb-4 mb-3">
                    <div className="position-relative z-3 w_fit_content mx-auto pupup_scale_sm_lable">
                      <img
                        className="position-absolute name_lable_image navbar_left_vector z_index_1 start-0"
                        src={button_yellow_left_layer}
                        alt="vector"
                      />
                      <img
                        className="position-absolute name_lable_image navbar_right_vector z_index_1 end-0"
                        src={button_yellow_right_layer}
                        alt="vector"
                      />
                      <button className="name_lable fs_sm_14">
                        {data.name}
                      </button>
                    </div>
                  </div>
                  <img
                    src={data.image}
                    className="w-100 max_sm_w popup_image"
                    alt="soul"
                  />
                </div>
                <div className="mt-4 mt-lg-0 para_soul_scroll_two pe-2">
                  <p className="text-dark-yellow font-sm fw-bold lh-160 mb-0 fs_sm_12">
                    {data.title}
                  </p>
                  <h2 className="text-soul-mx fw-bold font-xlg text-white lh-120 mt-2 fs_sm_16">
                    {data.heading}
                  </h2>
                  <p className="text-soul-mx mb-0 fw-normal text-white font-sm fs_sm_12 lh_25 pe-xl-2">
                    {showFullContentSecond
                      ? contentSecond
                      : `${contentSecond.slice(0, 300)}...`}
                    {!showFullContentSecond && (
                      <button
                        onClick={toggleContentSecond}
                        className="border-0 bg-transparent font-sm text-white font-norma"
                      >
                        Read More
                      </button>
                    )}
                  </p>
                  <p className="d-lg-none font-sm text-white font-normal lh_25 mt_36 mb-0 text-md-center text-lg-start fs_sm_12">
                    {data.subDescription}
                  </p>
                </div>
              </div>
              <div
                className={`max_w_full mx-auto d-none d-lg-block ${data.subDescriptionClass}`}
              >
                <p
                  className={`para-soul-scroll mobile_scrollbar font-sm text-white font-normal lh_25 mt_36 mb-0 text-md-center text-lg-start fs_sm_12 pe-2 ${data.subDescriptionClass}`}
                >
                  {showFullContent
                    ? content
                    : `${content.slice(0, characterLimit)}...`}
                  {!showFullContent && (
                    <button
                      onClick={toggleContent}
                      className="border-0 bg-transparent font-sm text-light-yellow font-norma"
                    >
                      Read More
                    </button>
                  )}
                </p>
              </div>
            </div>
          </div>
          <img
            className="d-lg-none popup_top_img mb_min_1 w-100"
            src={popuptop_bottom_layer}
            alt="popuptop-bottom-layer"
          />
        </div>
      </div>
    </>
  );
};

export default Modal;
